import { z } from 'zod';
/*
  AuthType defines the available authentication methods
*/
export var AuthType;
(function (AuthType) {
    AuthType["Session"] = "session";
    AuthType["ApiKey"] = "apiKey";
})(AuthType || (AuthType = {}));
/*
  authTypeSchema is the Zod schema for validating auth types
*/
export const authTypeSchema = z.enum(AuthType);
/*
  User identity schema - basic authenticated user information
*/
export const userIdentitySchema = z.object({
    id: z.string(),
    email: z.email().nullable(),
    authType: authTypeSchema,
    organizationId: z.string().optional(),
    organizationName: z.string().nullable().optional(),
    keyPrefix: z.string().nullable().optional(),
});
/*
  API Key schemas
*/
export const apiKeyGenerationSchema = z.object({
    apiKey: z.string(),
    message: z.string(),
});
export const apiKeyStatusSchema = z.object({
    hasKey: z.boolean(),
    createdAt: z.coerce.date().nullable().optional(),
    keyPrefix: z.string().nullable().optional(),
    lastUsedAt: z.coerce.date().nullable().optional(),
});
/*
  Auth event response schema (login/logout)
*/
export const authEventResponseSchema = z.object({
    success: z.boolean(),
});
//# sourceMappingURL=account.js.map